<form class="generate-accounts-form" [formGroup]="formGroup">
  <div class="text-white text-xl mt-4">
    Pick a Wallet Directory
  </div>
  <div class="my-4 text-hint text-lg leading-snug">
    Enter the directory where you want to store your wallet. By default, a wallet will be created at {{linux}} for Linux machines, {{macos}} for MacOS, or {{windows}} for windows computers, leave blank to use the default value.
  </div>
  <mat-form-field appearance="outline">
    <mat-label>Enter desired wallet directory</mat-label>
    <input
      matInput
      formControlName="walletDir"
      name="walletDir"
    />
  </mat-form-field>
</form>
